import { SelectionModel } from '@angular/cdk/collections';
import { cloneDeep } from 'lodash';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { FilterCheckboxConfiguration } from '@app-model/company';
import { CheckedOption, Utils } from '@app-shared/utils';
import { Observable } from 'rxjs';
import { TreeNodeItem } from '@app-model/check-list-database';
@Component({
    selector: 'app-checkbox-store',
    templateUrl: './checkbox-store.component.html',
    styleUrls: ['./checkbox-store.component.scss'],
    standalone: false
})
export class CheckboxStoreComponent implements OnInit, OnChanges {
  @Input()
  subAreasOptions: CheckedOption[] = [];

  @Input()
  attrFilterState?;

  @Input()
  attrFilter?;

  @Input()
  sideFilter: FilterCheckboxConfiguration;

  @Input()
  subAreasObservable: Observable<CheckedOption[]>;

  @Input()
  enableScroll? = true;

  @Input()
  attrLabel? = 'name';

  @Input()
  checkBoxAll? = false;

  @Input()
  boldSelectAll? = true;

  @Input()
  allSelect? = false;

  @Output()
  selectEvt = new EventEmitter<any>();

  @Input()
  allPhase? = 'Todos';

  @Input()
  onlySelected? = false;

  @Input()
  onlyView? = false;

  @Input()
  hideSelected? = false;

  @Input()
  onlySelectedOneOption? = false;

  @Input()
  state;

  @Output()
  onChangeCheckbox = new EventEmitter<any>();

  dataSource: MatTreeNestedDataSource<CheckedOption>;
 
  checklistSelection = new SelectionModel<CheckedOption>(true);
  childrenAccessor = (node:any) => node.children ?? [];
  constructor() {
    
    this.dataSource = new MatTreeNestedDataSource();
  }

  ngOnInit() {
    this.subAreasOptions = cloneDeep(this.state);
    this.dataSource.data = this.subAreasOptions;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.state){
      this.subAreasOptions = cloneDeep(changes.state.currentValue);
      this.dataSource.data = this.subAreasOptions;
    }

    if(changes.allSelect){
      if(changes.allSelect.currentValue){
        this.selectAllOptions();
      } else {
        this.cleanFilter();
      }
    }
  }

  hasChild = (_: number, node: CheckedOption) => {
    return node.children && node.children.length > 0;
  };

  selectOnecheck(node: CheckedOption, evt: MatCheckboxChange) {
    node.checked = evt.checked;
    this.onChangeCheckbox.emit(node);
  }

  // descendantsAllSelected(node: CheckedOption) {
  
  //   return this.descendantsTest(node, true);
  // }

  private descendantsTest(node: CheckedOption, isFirst): boolean {
    if (!isFirst && !node.checked) {
      return false;
    }
    let flag = true;
    if (node.children && node.children.length > 0) {
      node.children.forEach((c) => {
        if (!this.descendantsTest(c, false)) {
          flag = false;
        }
      });
    }
    return flag;
  }

  // descendantsPartiallySelected(node: CheckedOption) {
  //   return this.descendantsPartiallyTest(node, true);
  // }

  private descendantsPartiallyTest(node: CheckedOption, isFirst): boolean {
    if (!isFirst && !node.checked) {
      return false;
    }
    if (!node.children) {
      return node.checked;
    }

    let isAllSelect = true; //
    let atLastOneSlect = false;
    if (node.children && node.children.length > 0) {
      node.children.forEach((c) => {
        if (this.descendantsPartiallyTest(c, false)) {
          atLastOneSlect = true;
        } else {
          isAllSelect = false;
        }
      });
    }
    return atLastOneSlect && !isAllSelect;
  }

  getData() {
    return {
      sideFilter: this.attrFilterState,
      data: this.subAreasOptions,
    };
  }

  selectParentNode(node: CheckedOption, evt: MatCheckboxChange) {
    this.toogleAllNodes(node, evt.checked);
    this.onChangeCheckbox.emit(node);
  }

  toogleAllNodes(node: CheckedOption, flag: boolean) {
    node.checked = flag;
    if (node.children && node.children.length > 0) {
      node.children.forEach((n) => {
        this.toogleAllNodes(n, flag);
      });
    }
  }

  cleanFilter() {
  // Utils.clearCheckedOptionRecursive(this.subAreasOptions, false);
    this.onChangeCheckbox.emit(this.subAreasOptions);
  }

  selectAllOptions() {
   // Utils.clearCheckedOptionRecursive(this.subAreasOptions, true);
    this.onChangeCheckbox.emit(this.subAreasOptions);
  }




    getNodeCheckedState(node: CheckedOption): boolean {
    if (node.children && node.children.length > 0) {
      return this.descendantsAllSelected(node);
    }
    return node.checked;
  }

  // Check if all descendants are selected
  descendantsAllSelected(node: CheckedOption): boolean {
    if (!node.children || node.children.length === 0) {
      return node.checked;
    }

    return node.children.every(child => this.descendantsAllSelected(child));
  }

  // Check if some descendants are selected (for indeterminate state)

  descendantsPartiallySelected(node: CheckedOption): boolean {
    if (!node.children || node.children.length === 0) {
      return false;
    }

    const selectedCount = node.children.filter(child => 
      this.descendantsAllSelected(child) || child.checked
    ).length;

    return selectedCount > 0 && selectedCount < node.children.length;
  }

}
